var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentLoader,{ref:"dynamicComp",tag:"component",attrs:{"comp":_vm.comp},on:{"on-show-task":function($event){return _vm.$emit('on-show-task', $event)},"on-course-info":function($event){return _vm.$emit('on-course-info', $event)},"on-tsk-info":function($event){return _vm.$emit('on-tsk-info', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }